import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import {TextMaskModule} from 'angular2-text-mask';




import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {UserService} from '../../../common/user.service';
import { CountryService } from '../../../common/country.service';


@Component({
  selector: 'edit-supplier-attendee',
  templateUrl: './edit-attendee.component.html',
  styleUrls: ['./edit-attendee.component.css','../../../app.component.css'],
  providers: [UserService,CountryService]
})
export class EditSupplierAttendeeComponent implements OnInit {
  userId: any;
  eventId: any;
  detailArray :any;
  errorMessage : any;
  users: any;
  countries:any;
  states:any;
  flags:any;
  counts: any;
  spinner: boolean = false;
  htmlVariable: string='';
  eventUserId:any;
  phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];



  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<EditSupplierAttendeeComponent>, private formBuilder: FormBuilder, private userService: UserService,private snackBar: MdSnackBar,private countryService:CountryService) { }

  ngOnInit() {
    if(this.eventId && this.userId){
      this.getAttendeeInfo(this.eventId,this.userId)
    }else{
      this.snackBar.open('something went wrong','',{duration:4000});
      setTimeout(()=>{ window.location.reload();}, 2000);
    }

    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
    });

    this.users = {
      firstName : '',
      lastName : '',
      email : '',
      cellPhone : '',
      userId:this.userId,
      eventUser : {
        eventId : this.eventId,
        badgeName : '',
	firstName : '',
	lastName : '',
	cellPhone : '',
        designation : '',
        type:'',
        attendAwardCelebration : '',
        mealRestriction : 0,
        mealChoice : 0,
        mealComments : '',
        companyName : '',
        addressLine1 : '',
        addressLine2 : '',
        countryId : '',
        stateId : '',
        stateName : '',
        countryName : '',
        city : '',
        zipcode : '',
        workPhone : '',
        extension : '',
      }
    };
  }

  countryChanged(params){
    this.spinner = true;
    this.countryService.getStates(this.users.eventUser.countryId).subscribe(
            response => {
          this.spinner = false;
          if(params!=1)
          this.users.eventUser.stateId='';
          this.states = response;
        },
            error => {
          this.spinner = false;
          this.snackBar.open(error,'',{duration:4000});
        }
    );

    if(params.apply)
    {
      for(var i=0;i<this.countries.length;i++)
        if(this.countries[i].id==this.users.eventUser.countryId)
          this.users.eventUser.countryName = this.countries[i].name;
    }
  }

  stateChanged(){
    for(var i=0;i<this.states.length;i++)
      if(this.states[i].id==this.users.eventUser.stateId)
        this.users.eventUser.stateName = this.states[i].name;
  }

  getAttendeeInfo(eventId,userId){
    this.spinner = true;
    this.userService.getAttendeeInfo({eventId:eventId,userId:userId,eventUserId:this.eventUserId,type:'Supplier'}).subscribe(
            response => {
          this.spinner = false;
          this.detailArray = response;
              if(response.attendeeInfo.length>0) {
                this.users = {
                  firstName: response.attendeeInfo[0].firstName,
                  lastName: response.attendeeInfo[0].lastName,
                  email: (response.attendeeInfo[0].email)?response.attendeeInfo[0].email:'',
                  cellPhone: (response.attendeeInfo[0].cellPhone)?response.attendeeInfo[0].cellPhone:'',
                  userId: this.userId,
                  eventUser: {
                    eventId: this.eventId,
                    eventUserId:(response.attendeeInfo[0].id)?response.attendeeInfo[0].id:'',
                    badgeName: (response.attendeeInfo[0].badgeName)?response.attendeeInfo[0].badgeName:'',
                    firstName: response.attendeeInfo[0].firstName,
                    lastName: response.attendeeInfo[0].lastName,
                    cellPhone: (response.attendeeInfo[0].cellPhone)?response.attendeeInfo[0].cellPhone:'',
                    designation: (response.attendeeInfo[0].designation)?response.attendeeInfo[0].designation:'',
                    type:(response.attendeeInfo[0].type)?response.attendeeInfo[0].type:'',
                    attendAwardCelebration: (response.attendeeInfo[0].attendAwardCelebration)?response.attendeeInfo[0].attendAwardCelebration:0,
                    mealRestriction: (response.attendeeInfo[0].mealRestriction)?response.attendeeInfo[0].mealRestriction:0,
                    mealChoice: (response.attendeeInfo[0].mealChoice)?response.attendeeInfo[0].mealChoice:0,
                    mealComments: (response.attendeeInfo[0].mealComments)?response.attendeeInfo[0].mealComments:'',
                    companyName: (response.attendeeInfo[0].companyName)?response.attendeeInfo[0].companyName:'',
                    addressLine1: (response.attendeeInfo[0].addressLine1)?response.attendeeInfo[0].addressLine1:'',
                    addressLine2: (response.attendeeInfo[0].addressLine2)?response.attendeeInfo[0].addressLine2:'',
                    countryId: (response.attendeeInfo[0].countryId)?response.attendeeInfo[0].countryId:0,
                    stateId: (response.attendeeInfo[0].stateId)?response.attendeeInfo[0].stateId:0,
                    stateName: (response.attendeeInfo[0].stateName)?response.attendeeInfo[0].stateName:'',
                    countryName: (response.attendeeInfo[0].countryName)?response.attendeeInfo[0].countryName:'',
                    city: (response.attendeeInfo[0].city)?response.attendeeInfo[0].city:'',
                    zipcode: (response.attendeeInfo[0].zipcode)?response.attendeeInfo[0].zipcode:'',
                    workPhone: (response.attendeeInfo[0].workPhone)?response.attendeeInfo[0].workPhone:'',
                    extension: (response.attendeeInfo[0].extension)?response.attendeeInfo[0].extension:''
                  }
                };
                this.countryChanged(1);
              }else{
                this.spinner = false;
                this.snackBar.open('something went wrong','',{duration:4000});
                setTimeout(()=>{ window.location.reload();}, 2000);
              }
        },
            error => {
          this.spinner = false;
          this.errorMessage = <any>error;
        }
    );
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
    var re = /^[0-9]{10}$/;
    return re.test(phone.replace(/-/g, ""));
  }

  validateZip(zip,country){
    return true;
    // if(country=='Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  validateDigit(num,min,max){
    return num.match("^[0-9]{"+min+","+max+"}$");
  }

  editAtt(attendeeForm){
    //console.log(this.FormValid(attendeeForm));

    if(attendeeForm.valid && this.FormValid(attendeeForm)){
      this.spinner = true;
      this.userService.editSupplierAttendee({  users:this.users }).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              if(this.users.eventUser.designation=='Main User'){
                localStorage.setItem('userInfo',JSON.stringify(response.userInfo));
              }
              this.snackBar.open('Attendee updated successfully','',{duration:4000});
              this.dialogRef.close(response.status);
            }
            else{
              this.snackBar.open(response.msg,'',{duration:4000});
              this.spinner = false;
            }
          },
              error => {
            this.spinner = false;
          }
      );
    }
  }


  FormValid(Id){
    var flag = true;
    if(this.users.eventUser.designation=='Business Attendee' || this.users.eventUser.designation=='Main User'){
      if(flag  && !this.validateEmail(this.users.email))
      {
        flag = false;
      }
      if(flag && !this.validatePhone(this.users.eventUser.cellPhone))
      {
        flag = false;
      }
    }else{
      if(flag && this.users.email && !this.validateEmail(this.users.email))
      {
        flag = false;
      }
      if(flag && this.users.eventUser.cellPhone && !this.validatePhone(this.users.eventUser.cellPhone))
      {
        flag = false;
      }
    }

    if(flag && !this.users.eventUser.firstName)
    {
      flag = false;
    }
    if(flag && !this.users.eventUser.lastName)
    {
      flag = false;
    }
    if(flag && !this.users.eventUser.badgeName)
    {
      flag = false;
    }

    return flag;
    //if(this.users.eventUser.designation=='Main User' && flag){
    //    this.userService.checkEmail({eventId:this.eventId,userId:this.userId,email:this.users.email}).subscribe(
    //            response => {
    //                if(response.status==true){
    //                  this.flags = true;
    //                  this.htmlVariable = '';
    //                }else{
    //                  this.flags = false;
    //                  this.htmlVariable = 'Email already taken';
    //                }
    //            },
    //            error => {
    //              this.flags = false;
    //          this.errorMessage = <any>error;
    //        }
    //    );
    //}
    //  if(flag && this.flags)
    //    return true;
    //  else
    //    return false;
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/edit-attendee/edit-attendee.component.ts